import { MATERIAL, MODEL_ID } from 'Pods/ThreeDStudio/Store/constants'

const PROVIDER_KEY = 'tencent_hunyuan'

/**
 * Inverse of parseTencentImageTo3dProData. Builds an openedModel-shaped payload
 * from the current modelSettings so the just-submitted run can be reopened
 * without an extra API round-trip.
 *
 * @param {Object} state - ThreeDStudio store state (getState())
 * @param {string|number} id - Run id from the generation API response
 * @returns {Object} - openedModel payload accepted by parseTencentImageTo3dProData
 */
export const buildTencentImageTo3dProFromState = (state, id) => {
  const { modelSettings } = state
  const {
    material,
    targetPolycount,
    polygonType,
    inputImage,
    inputImageUrl,
    isPrivate,
    selectedUseCase,
  } = modelSettings || {}

  const inputAssets = inputImage != null
    ? [{
        assetType: 'image',
        source: 'user_upload',
        assetId: inputImage,
        fileUrl: inputImageUrl,
      }]
    : undefined

  return {
    id,
    providerKey: PROVIDER_KEY,
    providerModelId: MODEL_ID.TENCENT_IMAGE_TO_3D_PRO,
    enablePbr: material === MATERIAL.PBR,
    geometryOnly: material === MATERIAL.GEOMETRY_ONLY,
    private: isPrivate,
    useCase: selectedUseCase,
    inputAssets,
    providerRunAttributes: {
      ...(targetPolycount != null && { faceCount: targetPolycount }),
      ...(polygonType != null && { polygonType }),
    },
  }
}
